import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";

/**
 * Generated class for the SearchSelectComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "search-select",
  templateUrl: "search-select.html",
})
export class SearchSelectComponent implements OnInit {
  @Input() group: FormGroup;
  @Input() config;

  id: string;
  componentId: string;
  label: any;
  disabled: boolean = false;
  readonly: boolean = false;

  searchString: string = "";
  dataRows: string[] = [];
  filteredDataRows: string[] = [];
  chips: string[] = [];

  constructor(public formBuilder: FormBuilder) {
    // console.log('Hello SearchSelectComponent Component');
  }

  ngOnInit(): void {
    // console.log( "Group: " );
    // console.log( this.group );
    // console.log( "Search-Select config: " );
    // console.log( this.config );

    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = this.config.readonly;

    this.dataRows = this.config.options;
    this.filteredDataRows = this.dataRows.slice(0);

    this.group.controls[this.id].valueChanges.subscribe((data) => {
      // console.log( "New outer value: ", data );
      if (data !== undefined && data !== this.chips) {
        // console.log( "New value for search select: ", data );

        if (data == null) {
          if (this.chips.length > 0) {
            for (let chip of this.chips) {
              this.deleteChip(chip);
            }
          }
        } else {
          for (let val of data) {
            // console.log( "Setting value: ", val );
            this.createChip(val, false);
          }
        }
        this.updateOuterValue();
      }
    });
  }

  onInput(event) {
    // console.log( "I got input!: ",  );
    this.filteredDataRows = this.dataRows.filter(
      (val) =>
        val.toLowerCase().startsWith(this.searchString.toLowerCase()) &&
        this.chips.indexOf(val) == -1
    );
    this.resetFillerRows();
  }

  onCancel(event) {
    // console.log( "I got cancelled!: ", event );
    this.filteredDataRows = this.dataRows;
    this.resetFillerRows();
  }

  updateOuterValue() {
    this.group.controls[this.id].setValue(this.chips);
    // console.log( "New outer value: ", this.group.controls[this.id].value );
  }

  createChip(id, updateValue = true) {
    if (id === "" || this.chips.indexOf(id) !== -1) {
      return;
    }

    let selected = this.filteredDataRows.splice(
      this.filteredDataRows.indexOf(id),
      1
    )[0];
    this.chips.push(selected);
    if (updateValue) {
      this.updateOuterValue();
    }

    this.updateWithFillerRows();
  }

  deleteChip(id) {
    // console.log( "Deleting that chip!:", id );
    if (this.readonly) {
      return;
    }
    let deleted = this.chips.splice(this.chips.indexOf(id), 1)[0];
    if (deleted.toLowerCase().startsWith(this.searchString.toLowerCase())) {
      this.filteredDataRows.push(deleted);
      this.filteredDataRows.sort();
    }
    // console.log( "Filtered rows post chip deletes: ", this.filteredDataRows );
    this.updateOuterValue();

    this.resetFillerRows();
  }

  updateWithFillerRows() {
    let entries: number = this.filteredDataRows.length;
    if (entries < 7) {
      for (let i = entries; i < 7; i++) {
        this.filteredDataRows[i] = "";
      }
    }
  }

  resetFillerRows() {
    this.filteredDataRows = this.filteredDataRows.filter((val) => val !== "");
    this.updateWithFillerRows();
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/search-select/search-select.ts